import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { Auth0Provider } from '@auth0/auth0-react'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { HashRouter as Router } from 'react-router-dom'
import config from './config'

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FFD700', // EQ gold color
      light: '#FFE44D',
      dark: '#B29600',
      contrastText: '#000',
    },
    secondary: {
      main: '#1E3F66', // Deep EQ blue
      light: '#2C5C94',
      dark: '#142B47',
      contrastText: '#fff',
    },
    background: {
      default: '#1A1A1A', // Dark stone
      paper: '#2A2A2A', // Lighter stone
    },
    text: {
      primary: '#FFD700', // Gold text
      secondary: '#B8B8B8', // Stone gray text
    },
    divider: '#3A3A3A', // Darker stone for borders
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0, // Square buttons like classic EQ
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 0, // Square panels like classic EQ
          backgroundImage: 'none', // Remove default paper elevation gradient
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none', // Remove default AppBar gradient
          backgroundColor: '#142B47', // Deep blue for header
        },
      },
    },
  },
  typography: {
    fontFamily: '"Cinzel", "Roboto", "Helvetica", "Arial", sans-serif', // Medieval-style font
    h1: {
      fontFamily: 'Cinzel',
    },
    h2: {
      fontFamily: 'Cinzel',
    },
    h3: {
      fontFamily: 'Cinzel',
    },
    h4: {
      fontFamily: 'Cinzel',
    },
    h5: {
      fontFamily: 'Cinzel',
    },
    h6: {
      fontFamily: 'Cinzel',
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Auth0Provider
          domain={config.auth0.domain}
          clientId={config.auth0.clientId}
          authorizationParams={{
            redirect_uri: `${window.location.origin}/#/`,
            audience: config.auth0.audience
          }}
        >
          <App />
        </Auth0Provider>
      </ThemeProvider>
    </Router>
  </React.StrictMode>
)
